const UserLaptop = ({ width = 20, height = 20, color = 'currentColor' }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 32 31" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.5 6.5C10.5 3.46243 12.9624 1 16 1C19.0376 1 21.5 3.46243 21.5 6.5C21.5 9.5376 19.0376 12 16 12C12.9624 12 10.5 9.5376 10.5 6.5Z"
        fill={color}
      />
      <path fillRule="evenodd" clipRule="evenodd" d="M18.2897 18H31.6031L26.7118 28H13.3984L18.2897 18Z" fill={color} />
      <path fillRule="evenodd" clipRule="evenodd" d="M10 26H16V28H10V26Z" fill={color} />
      <path
        d="M16 14C9.40609 14 4 19.2142 4 25.7189V26.4542L4.70706 26.6263C5.80456 26.8934 6.90223 27.1215 8 27.3107V26.0001C8 24.8955 8.89543 24.0001 10 24.0001H13.1277L16.4924 17.1213C16.828 16.4352 17.5251 16.0001 18.2889 16.0001H22.7056C20.7872 14.7361 18.4774 14 16 14Z"
        fill={color}
      />
    </svg>
  );
};
export default UserLaptop;
